<template>
    <ul class="bisnode-tree list-unstyled mb-0 ml-0 p-0">
        <tree-node :node="root" :is-root="true" />
    </ul>
</template>

<script>
// En liten rekursiv komponent som ritar en nod + dess barn
const TreeNode = {
    name: 'TreeNode',
    props: {
        node: { type: Object, required: true },
        isRoot: { type: Boolean, default: false },
    },
    computed: {
        hasChildren() {
            return Array.isArray(this.node.companies) && this.node.companies.length > 0;
        },
        country() {
            return this.node.countryCode || '';
        },
        regNo() {
            return this.node.identifiers && this.node.identifiers.registrationNumber;
        },
    },
    methods: {
        fmtOwnership(p) {
            if (p === undefined || p === null || p === '') return null;
            return `${p}%`;
        },
    },
    render(h) {
        // Själva nodkapseln
        const capsule = h(
            'div',
            {
                staticClass: 'card py-1 px-2 mb-2 d-inline-flex flex-row align-items-center',
            },
            [
                h('div', { staticClass: 'pr-2' }, [
                    h('div', { staticClass: 'font-weight-semibold' }, this.node.name),
                    h('div', { staticClass: 'small text-muted' }, [
                        this.country ? `(${this.country})` : '',
                        this.regNo ? ` · ${this.regNo}` : '',
                    ]),
                ]),
                this.node.ownershipInPercent
                    ? h(
                        'span',
                        { staticClass: 'badge badge-pill badge-secondary ml-2' },
                        this.fmtOwnership(this.node.ownershipInPercent),
                    )
                    : null,
            ],
        );

        // Barnlista
        const children = this.hasChildren && h(
            'ul',
            { staticClass: 'bisnode-tree list-unstyled mb-0' },
            this.node.companies.map((child) => h(
                TreeNode,
                { props: { node: child, isRoot: false } },
            )),
        );

        // Returnera <li> + kapsel + ev barn
        return h(
            'li',
            { staticClass: 'bisnode-tree-item', class: this.isRoot ? 'is-root' : '' },
            [
                capsule,
                children,
            ],
        );
    },
};

export default {
    name: 'CompanyTree',
    components: { TreeNode },
    props: {
        // Rot-objektet (din JSON)
        root: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style>
/* UL/LI-baserat träd med linjer via pseudo-element */
.bisnode-tree {
    position: relative;
    margin-left: 1.25rem; /* plats för vertikal linje */
    padding-left: 0.75rem; /* plats för horisontell gren */
}

.bisnode-tree .bisnode-tree-item {
    position: relative;
    margin: 0.75rem 0;
}

/* Vertikal linje (ryggrad) */
.bisnode-tree .bisnode-tree-item:not(.is-root)::before {
    content: "";
    position: absolute;
    left: -1rem;      /* förskjutning så den hamnar utanför kapseln */
    top: -0.75rem;
    bottom: -0.75rem;
    width: 1px;
    border-left: 2px solid #c7ced7;
}

/* Horisontell gren som ansluter in till noden */
.bisnode-tree .bisnode-tree-item:not(.is-root)::after {
    content: "";
    position: absolute;
    left: -1rem;
    top: 1.15rem; /* höjd ungefär vid mitten av kapseln */
    width: 1rem;
    border-top: 2px solid #c7ced7;
}

/* Roten ska bara ha vertikal ryggrad ovanför sig, inte över hela höjden */
.bisnode-tree > .is-root::before {
    top: 1.15rem;   /* börja rita ryggraden strax under roten */
}

/* Sista barnet får inte rita vertikal linje nedanför sig */
.bisnode-tree .bisnode-tree-item:last-child::before {
    bottom: 2.4rem;
}
</style>
